import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';

const Autonomize = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const location = useLocation();
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const hasCalledAPI = useRef(false);

    useEffect(() => {
        // Prevent duplicate calls
        if (hasCalledAPI.current) return;

        try {
            window.history.pushState("you are being redirected...", "Redirect", "/redirect");
        } catch (err) {
            if (typeof console !== 'undefined') console.log(err);
        }

        const queryParams = new URLSearchParams(location.search);
        const params = {};

        queryParams.forEach((value, key) => {
            params[key] = value;
        });

        console.log('Extracted Params:', params);

        // Mark that we're about to call the API
        hasCalledAPI.current = true;
        fetchAutonomizeURL(params);
    }, [location]);

    const fetchAutonomizeURL = async (params) => {
        try {
            console.log('API Request Params:', params);
            const response = await axios.get(`${API_URL}/api/Autonomize/GetAutonomizeNMCCPUrl`, {
                params: {
                    ...params
                }
            });

            
            if (response.data && response.data.url) {

                if (response.data.url.includes('NO_ACCESS')) {
                    setLoading(false);
                    setError('NO_ACCESS');
                    return; // ✅ stop here, do NOT redirect
                }

                // ✅ Direct redirection
                window.location.href = response.data.url;

            } else {
                setLoading(false);
                setError('AutonomizeNMCCP');
            }
        } catch (error) {
            console.error('Error fetching Autonomize URL:', error);
            setLoading(false);
            setError('AutonomizeNMCCP');
        }
    };

    return (
        <div>
            <table style={{ backgroundColor: 'transparent' }} cellPadding="0" cellSpacing="0">
                <tbody>
                    <tr style={{ height: '100%' }}>
                        <td></td>
                    </tr>
                    <tr>
                       
                        <td align="center" style={{ width: '100%', fontSize: 'large' }}>

                            {error === 'NO_ACCESS' && (
                                <div style={{ color: 'red', fontWeight: 'bold' }}>
                                    Only Medicaid and Dual Members have access.No Marketplace members have access.
                                </div>
                            )}

                            {error && error !== 'NO_ACCESS' && (
                                <ErrorPage errorType="AutonomizeNMCCP" />
                            )}
                           
                        </td>
                        {/*<td style={{ width: '30%' }}></td>*/}
                    </tr>
                    <tr>
                        <td style={{ width: '50%' }}></td>
                        <td align="center" style={{ fontSize: 'large' }}>
                            {loading && <img src={LoadingImage} id="loadinggif" style={{ alignContent: 'center' }} alt="Loading" />}
                        </td>
                        <td style={{ width: '50%' }}></td>
                    </tr>
                    <tr>
                        <td style={{ width: '30%' }}></td>
                        <td align="center">
                            <div style={{ fontSize: 'larger' }}></div>
                        </td>
                        <td style={{ width: '30%' }}></td>
                    </tr>
                    <tr style={{ height: '30%' }}>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Autonomize;